import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import {
  identifyWebSignupLogRocketUser,
  isWebLogRecordingEnabled,
  syncWebLogRecordFromQuery,
} from "../utils/webLogRocketRecord";

export const useWebLogRocketProvider = (): void => {
  const location = useLocation();

  useEffect(() => {
    syncWebLogRecordFromQuery();

    if (!isWebLogRecordingEnabled()) return;

    const searchParams = new URLSearchParams(location.search);
    const userId = searchParams.get("userId");
    if (!userId?.trim()) return;

    const emailAddress = searchParams.get("emailAddress") || undefined;
    const signedUpFullName = searchParams.get("signedUpFullName");
    const name = signedUpFullName
      ? signedUpFullName.split("_").join(" ")
      : undefined;

    void identifyWebSignupLogRocketUser({
      userId,
      email: emailAddress,
      name,
    });
  }, [location.pathname, location.search]);
};
